export const mapUserDto = (dto) => ({
    id: dto.id,
    username: dto.username,
    name: dto.name,
    role: dto.role,
    passwordClear: dto.passwordClear,
    is_active: dto.is_active ?? dto.isActive,
    projects: dto.projects,
});